import React from "react";
import { Store, ShoppingBag } from "lucide-react";
import { fileUrl } from "@/lib/uploads";
import { openProduct } from "@/lib/navigation";
import { useI18n } from "@/context/I18nContext";
import { formatPrice } from "@/lib/currency";

// A compact card for a shared marketplace product (used in chat & social).
// `data` is the product_ref snapshot {id,title,price,promo_price,currency,image,shop_name}.
export default function ProductRefCard({ data }) {
  const { t } = useI18n();
  if (!data) return null;
  const img = data.image ? fileUrl(data.image) : null;
  const price = data.promo_price ?? data.price;
  return (
    <button
      onClick={(e) => { e.stopPropagation(); openProduct(data.id); }}
      data-testid={`product-ref-${data.id}`}
      className="flex items-center gap-3 w-full max-w-[16rem] rounded-xl border border-[var(--rc-border)] bg-[var(--rc-surface)] p-2 text-left hover:border-[var(--rc-gold)]/60 transition-colors"
    >
      <div className="h-14 w-14 rounded-lg overflow-hidden bg-[var(--rc-bg)] shrink-0 grid place-items-center">
        {img ? <img src={img} alt="" className="h-full w-full object-cover" /> : <ShoppingBag size={20} className="text-[var(--rc-muted)]" />}
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-[11px] text-[var(--rc-gold)] font-medium flex items-center gap-1 truncate"><Store size={11} /> {data.shop_name || t("m_product")}</div>
        <div className="text-sm font-medium truncate text-[var(--rc-text)]">{data.title}</div>
        {price != null && <div className="text-sm font-semibold text-[var(--rc-gold)]">{formatPrice(price, data.currency || "USD")}</div>}
        <div className="text-[10px] text-[var(--rc-muted)] mt-0.5">{t("m_view_product")}</div>
      </div>
    </button>
  );
}
